(function ($) {
  class LoadMore {
    /**
     * Constructor.
     */
    constructor() {
      this.ajaxUrl = siteConfig?.ajaxUrl ?? "";
      this.ajaxNonce = siteConfig.ajaxNonce ?? "";
      this.loadMoreBtn = $("#event-load-more");
      this.loadingSpinner = $("#load-more-spinner");
      this.provinceSelect = $(".js-province-form");

      this.isRequestProcessing = false;

      this.init();
    }

    init() {
      if (!this.loadMoreBtn.length) {
        return;
      }

      this.totalPagesCount = $("#post-pagination").data("max-pages");

      this.loadMoreBtn.click((event) => {
        event.preventDefault();
        this.handleLoadMorePosts();
      });
    }

    handleLoadMorePosts() {
      const page = this.loadMoreBtn.data("page");
      const isPaginationActive = this.loadMoreBtn.data("pagination");

      if (!page || this.isRequestProcessing) {
        return null;
      }

      const nextPage = parseInt(page) + 1;

      this.toggleLoading(true);

      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          page: page,
          isPaginationActive: isPaginationActive,
          action: "events_load_more",
          ajax_nonce: this.ajaxNonce,
        },
        success: (res) => {
          console.log("response", res);
          this.loadMoreBtn.data("page", nextPage);
          $("#load-more-content").append(res);
          this.removeLoadMoreIfOnLastPage(nextPage);
          this.toggleLoading(false);
        },
        error: (err) => {
          this.toggleLoading(false);
        },
      });
    }

    /**
     * Remove Load more Button If on last page.
     *
     * @param {int} nextPage New Page.
     */
    removeLoadMoreIfOnLastPage(nextPage) {
      if (nextPage + 1 > this.totalPagesCount) {
        this.loadMoreBtn.remove();
      }
    }

    /**
     * Toggle Loading
     *
     * Show or hide the loading text.
     *
     * @param isLoading
     */
    toggleLoading(isLoading) {
      this.isRequestProcessing = isLoading;

      if (isLoading) {
        this.loadingSpinner.show();
      } else {
        this.loadingSpinner.hide();
      }
    }
  }

  new LoadMore();
})(jQuery);
